import { Link } from "react-router-dom";
const MasterTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/companyprofile"}
          className={
            props.pageName === "COMPANYPROFILE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PROFILE
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/branchs"}
          className={
            props.pageName === "BRANCH"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          BRANCH
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/users"}
          className={
            props.pageName === "USER"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          USERS
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/changepassword"}
          className={
            props.pageName === "CHANGEPASSWORD"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          CHANGE PASSWORD
        </Link>
      </li>
    </ul>
  );
};

export default MasterTabs;
